import { Sorting01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const TransactionsEmptyState = () => (
  <div className="flex flex-col w-full flex-1 rounded-[8px] border border-alpha-100 bg-white shadow-xs overflow-hidden">
    <div className="flex items-center h-12 border-b px-4 py-3 gap-2">
      <div className="w-12 shrink-0" />
      <p className="flex-1 text-xs font-medium text-content-300">Name</p>
      <p className="w-28 text-xs font-medium text-content-300">Date</p>
      <div className="flex items-center justify-end gap-1">
        <p className="text-xs font-medium text-content-900">Amount</p>
        <HugeiconsIcon
          icon={Sorting01Icon}
          size={14}
          className="shrink-0 text-content-900"
        />
      </div>
    </div>
    <div className="flex-1 min-h-[120px] flex items-center justify-center">
      <p className="text-sm font-medium text-content-400">
        No transactions found
      </p>
    </div>
  </div>
);
